import Vue from 'vue';
import Router from 'vue-router';
import VueMeta from 'vue-meta';
import PageMain from './views/PageMain.vue';
import PageStatistics from './views/PageStatistics.vue';
import PageRating from './views/PageRating.vue';
import NotFound from './views/NotFound.vue';

Vue.use(Router);
Vue.use(VueMeta);

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'index',
      component: PageMain,
    },
    {
      path: '/statistics',
      name: 'statistics',
      component: PageStatistics,
    },
    {
      path: '/rating',
      name: 'rating',
      component: PageRating,
    },
    {
      path: '/statistics/:randomNumber',
      name: 'statisticsRandom',
      component: PageStatistics,
    },
    { 
    path: '/404', 
    name: '404', 
    component: NotFound, 
    },
    { 
      path: '*', 
      redirect: '/404' 
    },
  ],
});
